<app-organizer-timeslot-edition-shared-select-timeslots
  [previousUrl]="previousUrl"
  [activity]="activity"
  [timeslots]="timeslots"
  [formControl]="selectedTimeslots"
  (updateTimeslots)="onSubmit()"
>
</app-organizer-timeslot-edition-shared-select-timeslots>
<app-alert-modal
  #deleteTimeslotWarning
  [confirmLabel]="
    'organizer.manage_timeslot.delete_modal.confirm.button' | translate
  "
  [closeLabel]="
    'organizer.manage_timeslot.delete_modal.abort.button' | translate
  "
  (modalClose)="deleteTimeslotWarningModal.hide()"
  (modalConfirm)="updateTimeslots()"
>
  <ng-container modal-header>
    {{
      'organizer.manage_timeslot.delete_modal.header.delete_selection'
        | translate
    }}
  </ng-container>
  <ng-container modal-content>
    {{ 'organizer.manage_timeslot.delete_modal.text' | translate }}
  </ng-container>
</app-alert-modal>
